import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../useMessagingContext/index.js'

export const SellerIdentityTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()
  const {page} = useAnalyticsTrack()

  const config = domain.get('config')
  const pageName = config.get('page').TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME

  useMount(async () => {
    const getTrackingData = async () => {
      return domain.get('get_page_tracking_data_use_case').execute({
        page: pageName
      })
    }

    const pageTrackingData = await getTrackingData()

    page(pageTrackingData)
  })

  const {address, bankAccount, city, lastName, name, zipCode} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerIdentityModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t(`VEHICLE_TRANSACTION.SELLER_IDENTITY.MODAL.NOTIFICATION_TEXT`)}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionSellerIdentityModal-modalChildren">
                  <div className="mt-TransactionSellerIdentityModal-description">
                    {i18n.t('VEHICLE_TRANSACTION.SELLER_IDENTITY.MODAL.MAIN_TEXT')}
                  </div>
                  <div className="mt-TransactionSellerIdentityModal-contentWrapper">
                    <div className="mt-TransactionSellerIdentityModal-contentItem">
                      <strong>{i18n.t('VEHICLE_TRANSACTION.SELLER_IDENTITY.MODAL.OWNER_INFO')}</strong>
                    </div>
                    {name && lastName ? (
                      <div className="mt-TransactionSellerIdentityModal-contentItem">{`${name} ${lastName}`}</div>
                    ) : (
                      <></>
                    )}
                    {address && city ? (
                      <div className="mt-TransactionSellerIdentityModal-contentItem">{`${address}, ${city}`}</div>
                    ) : (
                      <></>
                    )}
                    {zipCode ? <div className="mt-TransactionSellerIdentityModal-contentItem">{zipCode} </div> : <></>}
                    <div className="mt-TransactionSellerIdentityModal-contentItem mt-TransactionSellerIdentityModal-contentItem--dimmed">
                      <IconCircleCheck size={ATOM_ICON_SIZES.medium} />
                      {i18n.t('VEHICLE_TRANSACTION.SELLER_IDENTITY.MODAL.ID_ATTACHED', {
                        accountNumberEnding: bankAccount?.slice(-4)
                      })}
                    </div>
                  </div>
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.SELLER_IDENTITY.MODAL.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
